import { render, staticRenderFns } from "./selectCities.vue?vue&type=template&id=3848c718&"
import script from "./selectCities.vue?vue&type=script&lang=js&"
export * from "./selectCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports